import pruneStaleAutomationThreads from '@/lib/threads/pruneStaleAutomationThreads.js';

/**
 * Drops persisted automation threads of one type that the server's authoritative
 * list no longer returns, so a deleted schedule, trigger, or workflow self-heals
 * on the next load. Skips reconciliation when the resolved list and the threads
 * slice describe different companies, so a stale cross-company response can never
 * evict live threads.
 */
const reconcilePersistedAutomationThreads = ({ state, threadType, automationItems = [], itemsScopeCompanyId = null } = {}) => {
  if (!state) {
    return state;
  }

  const threadsScopeCompanyId = String(state?.threadsScopeCompanyId || '').trim() || null;
  const normalizedItemsScopeCompanyId = String(itemsScopeCompanyId || '').trim() || null;

  if (threadsScopeCompanyId && normalizedItemsScopeCompanyId && threadsScopeCompanyId !== normalizedItemsScopeCompanyId) {
    return state;
  }

  const authoritativeThreadIds = (Array.isArray(automationItems) ? automationItems : []).map((item) => item?.threadId);
  const nextThreads = pruneStaleAutomationThreads({
    threads: state.threads,
    threadType,
    authoritativeThreadIds
  });

  if (nextThreads === state.threads) {
    return state;
  }

  return {
    ...state,
    threads: nextThreads
  };
};

export default reconcilePersistedAutomationThreads;
